import { Box, CardBody, CardFooter, CardHeader, FormControl, FormErrorMessage, FormLabel, Input, VStack } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { SubmitBtn } from "../../atoms/button/SubmitBtn";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";
import { useRegisterSalesmanLinkingForm } from "../../../hooks/ifreaAnalytics/useRegisterSalesmanLinkingForm";
import { useRegisterSalesmanLinking } from "../../../hooks/ifreaAnalytics/useRegisterSalesmanLinking";


export const RegisterSalesmanLinking = () => {
  const { salesmanId } = useParams();
  const { handleSubmit, register, isSubmitting, errors } = useRegisterSalesmanLinkingForm();
  const onSubmit = useRegisterSalesmanLinking(salesmanId);
  const ifreaAnalyticsSalesmanIdError = errors.ifrea_analytics_salesman_id?.message;
  return (
    <Box m='auto' w={{base: '100%', md: '600px'}}>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <DarkShadowCard>
          <CardHeader>
            <CardHeading icon={<SettingsIcon />} heading='ID紐づけ'/>
          </CardHeader>
          <CardBody py={2}>
            <VStack spacing={5}>
              <FormControl isRequired isInvalid={!!errors.ifrea_analytics_salesman_id} w='100%'>
                <FormLabel>ifreaアナリティクス営業マンID</FormLabel>
                <Input type="text" {...register('ifrea_analytics_salesman_id')} />
                <FormErrorMessage>{ifreaAnalyticsSalesmanIdError}</FormErrorMessage>
              </FormControl>
            </VStack>
          </CardBody>
          <CardFooter>
            <SubmitBtn isLoading={isSubmitting}>登録</SubmitBtn>
          </CardFooter>
        </DarkShadowCard>
      </form>
    </Box>
  );
};